import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { resetOrder } from 'actions/orderSearch';
import { setCancelerOrderItems } from 'actions/orderCancellation';
import { fetchOrder } from 'actions/orderSearch';
import $S from 'theme/settings';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app.json`);
const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

let _content = null;

const OrderCancelDetail = (props) => {
  const { resetOrder, setCancelerOrderItems, fetchOrder, pending } = props;

  const [skuFilter, setSkuFilter] = useState('');
  const [barcodeFilter, setBarcodeFilter] = useState('');
  const [refundInvoiceNumber, setCancelInvoiceNumber] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(false);
  const [refundedOrderItems, setCanceledOrderItems] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isCancelOrderButtonVisible, setIsCancelOrderButtonVisible] =
    useState(false);

  let localCancelOrderNumber = JSON.parse(
    localStorage.getItem('cancelOrderNumber')
  );

  const orderData = useSelector((state) => state.orderSearch.order);

  const [order, setOrder] = useState(Object.assign({}, orderData));
  const [orderCopyBarcode, setOrderCopyBarcode] = useState(
    Object.assign({}, orderData)
  );

  useEffect(() => {
    fetchOrder({ order: localCancelOrderNumber }, 'cancel');
  }, []);

  const toggleAllCheckbox = (checked) => {
    if (checked) {
      orderData.orderitem_set.forEach((oi) => {
        if (
          !refundedOrderItems[oi.pk] &&
          !(oi.status === '50' || oi.status === '100' || oi.status === '600')
        ) {
          refundedOrderItems[oi.pk] = oi.pk;
        }
      });
    } else {
      orderData.orderitem_set.forEach((oi) => {
        delete refundedOrderItems[oi.pk];
      });
    }
    setCanceledOrderItems(refundedOrderItems);
    setIsAllChecked(checked);
    setIsCancelOrderButtonVisible(checked);
  };

  const refundOrderItem = (order_item, action = true) => {
    if (order_item !== undefined) {
      if (action === true && !refundedOrderItems[order_item.pk]) {
        refundedOrderItems[order_item.pk] = order_item.pk;
      } else {
        delete refundedOrderItems[order_item.pk];
      }
      setCanceledOrderItems(refundedOrderItems);
      const hasObjectKeys = Object.keys(refundedOrderItems).length > 0;
      const isCancelOrderButtonVisible = $S.hasOrderCancelInvoiceNumber
        ? hasObjectKeys && !!refundInvoiceNumber
        : hasObjectKeys;
      setIsCancelOrderButtonVisible(isCancelOrderButtonVisible);
    }
  };

  const refundOrder = () => {
    localStorage.setItem('localCancelOrderData', JSON.stringify(orderData));
    localStorage.setItem(
      'localCanceledOrderItems',
      JSON.stringify(refundedOrderItems)
    );
    localStorage.setItem(
      'localCancelInvoiceNumber',
      JSON.stringify(refundInvoiceNumber)
    );
    setCancelerOrderItems(orderData, refundedOrderItems, refundInvoiceNumber);
    setRedirect(true);
    setRedirectUrl($R.ORDER_CANCELLATION_COMPLETE.path);
  };

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const filterBySku = (val) => {
    let orderState = orderData;
    if (val.trim().length) {
      orderState.orderitem_set = orderState.orderitem_set.filter((oi) => {
        return oi.product.sku === val;
      });
    } else {
      orderState = Object.assign({}, orderData);
    }
    setSkuFilter(val);
    setOrder(orderState);
  };

  const filterByBarcode = (val) => {
    val.persist();
    let orderState =
      Object.keys(orderCopyBarcode).length !== 0 ? orderCopyBarcode : orderData;

    const barcodeKey =
      $ST.BRAND === 'GANT'
        ? 'integration_erenp_erenbarkod'
        : 'integration_barcode';

    setTimeout(() => {
      if (
        (orderState !== undefined && orderState.orderitem_set !== undefined) ||
        orderState.length >= 1
      ) {
        let newOi =
          orderState.orderitem_set !== undefined
            ? orderState.orderitem_set.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] === val.target.defaultValue
              )
            : orderState.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] === val.target.defaultValue
              );

        let remainNewOi =
          orderState.orderitem_set !== undefined
            ? orderState.orderitem_set.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] !== val.target.defaultValue
              )
            : orderState.filter(
                (oi) =>
                  oi.product.attributes[barcodeKey] !== val.target.defaultValue
              );

        if (val.target.defaultValue) {
          setTimeout(() => {
            if (newOi.length > 1) {
              let orderState = orderCopyBarcode;
              setTimeout(() => {
                if (val.target.defaultValue) {
                  let newOi =
                    orderState.orderitem_set !== undefined
                      ? orderState.orderitem_set.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] ===
                            val.target.defaultValue
                        )
                      : orderState.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] ===
                            val.target.defaultValue
                        );

                  let remainNewOi =
                    orderState.orderitem_set !== undefined
                      ? orderState.orderitem_set.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] !==
                            val.target.defaultValue
                        )
                      : orderState.filter(
                          (oi) =>
                            oi.product.attributes[barcodeKey] !==
                            val.target.defaultValue
                        );

                  let multipleFilteredOi = newOi.filter(
                    (item) => item.pk !== newOi[0].pk
                  );

                  setBarcodeFilter(val.target.defaultValue);
                  setOrderCopyBarcode(remainNewOi.concat(multipleFilteredOi));

                  setTimeout(() => {
                    refundOrderItem(newOi[0], true);
                  }, 200);
                }
              }, 300);
            } else {
              refundOrderItem(newOi[0], true);
              setBarcodeFilter(val.target.defaultValue);
              setOrderCopyBarcode(remainNewOi.concat(newOi));
            }
          }, 200);
        }
      }
    }, 200);
  };

  const handleInputChange = (value) => {
    setCancelInvoiceNumber(value);
  };

  return (
    _content &&
    _content({
      props,
      skuFilter,
      barcodeFilter,
      refundInvoiceNumber,
      redirect,
      redirectUrl,
      refundedOrderItems,
      isAllChecked,
      isCancelOrderButtonVisible,
      order,
      pending,
      toggleAllCheckbox,
      refundOrderItem,
      refundOrder,
      cleanStateAndRedirect,
      filterBySku,
      filterByBarcode,
      handleInputChange,
    })
  );
};

const mapDispatchToProps = {
  setCancelerOrderItems,
  fetchOrder,
  resetOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderSearch.order,
  pending: state.orderSearch.pending,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderCancelDetail);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/cancellation/orderCancellationDetail/index.js